import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex: 0.5;
  flex-direction: column;
  gap: 8px;
`;

export const List = styled.div`
  display: flex;
  flex: 0.5;
  flex-direction: column;
`;

export const ListIcon = styled.div`
  background-color: var(--color-accent-primary-default);
  border: 1.6px solid var(--color-green-200);
  border-radius: var(--size-border-radius-circle);
  height: 24px;
  margin-right: 8px;
  width: 24px;
`;

export const ListItem = styled.li`
  background-color: var(--color-navy-t8);
  border-radius: var(--size-border-radius-md);
  display: flex;
  padding: 12px;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const ListP = styled.p`
  color: var(--color-accent-secondary-default);
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
`;

export const ModalBody = styled.div`
  display: flex;
  gap: 24px;
`;
